import React from 'react';
import {IconButton as NativeIconButton, CircularProgress} from '@material-ui/core';

class IconButton extends React.Component {
    render() {
        const {icon, color, style, iconStyle, onClick, loading} = this.props;

        return (
            <NativeIconButton color={color} style={style} onClick={onClick} disabled={loading}>
                {loading ?
                    <CircularProgress size={16} color={'primary'}/>
                    :
                    <i className={`fa fa-${icon}`} style={iconStyle}/>
                }
            </NativeIconButton>
        );
    }
}

export default IconButton;